import * as React from 'react'

import { LOCIZE_NAMESPACE } from 'main/common'
import { i18nKeyPrefix } from 'main/pages/Search/i18n'
import { SmartImage, Title, Visible } from 'main/ui'
import { IFilters, numberOfActiveFilters } from 'main/util/search'
import { useTranslation } from 'react-i18next'
import { Container, ContentContainer, ImageContainer, TitleContainer } from './NoResults.styles'

const PRE = `${i18nKeyPrefix}-LISTING-SECTION-NO-RESULTS`

interface IProps {
  filters: IFilters
}

export default function NoResults(props: IProps) {
  const { filters } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Container>
      <ContentContainer>
        <TitleContainer>
          <Title kind="section">
            {numberOfActiveFilters(filters) ? t(`${PRE}-FILTER`) : t(`${PRE}-TEXT`)}
          </Title>
        </TitleContainer>
        <Visible lg xl>
          <ImageContainer>
            <SmartImage critical uuid="4253790f-e281-4610-b7d2-1f4eb8d3e80e" />
          </ImageContainer>
        </Visible>
      </ContentContainer>
    </Container>
  )
}
